import React from "react";
import { Helmet } from "react-helmet-async";
import { PricingPlans } from "@/components/subscription/PricingPlans";
import { useAuth } from "@/hooks/useAuth";

const PricingPage: React.FC = () => {
  const { user } = useAuth();
  const isGuest = user && user.role === 'guest';

  return (
    <>
      <Helmet>
        <title>Pricing | SaunaDip</title>
        <meta name="description" content="Pick your subscription plan and unlock the full potential of SaunaDip for your sauna business." />
      </Helmet>
      <div className="bg-gradient-to-b from-sauna-beige/30 to-white py-16 px-4">
        <div className="max-w-7xl mx-auto">
          {isGuest && (
            <div className="bg-sauna-orange/10 border border-sauna-orange rounded-lg px-4 py-5 mb-8 text-center flex flex-col items-center">
              <div className="text-sauna-orange font-semibold text-lg mb-2">
                Operator plans are for business owners who want to list their sauna and unlock more features!
              </div>
              <div className="text-sauna-navy mb-4 text-base">
                Interested in growing your sauna business? <br />Become an operator and get started today.
              </div>
              <a href="/become-operator" className="inline-block bg-sauna-orange hover:bg-sauna-orange/90 text-white font-bold px-6 py-2 rounded-lg shadow transition">
                Become an Operator
              </a>
            </div>
          )}
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-sauna-navy mb-4">Pick Your Subscription Plan</h1>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Get the ultimate online presence for your sauna business with SaunaDip Premium — try it risk-free.
            </p>
          </div>
          {/* Shared PricingPlans component for plan cards and pricing */}
          <PricingPlans />
        </div>
      </div>
    </>
  );
};

export default PricingPage;
